import React, { useContext, useEffect, useState } from "react";
import "../Components/Tickets/Tickets.css";
import { techappContext } from "../../Api/techappReq";
import Loading from "../Components/loading/index";
import Empty from "../Components/empty";
import TicketCard from "../Components/ticket-card";
import loadingSvg from "../../assets/images/loadingSvg.svg";
import loadMoreIcon from "../../assets/images/collapse-close.png";

const TicketPage = () => {
  const {
    getTickets,
    tickets,
    getBadgesReq,
    totalPage,
    loading,
    paginateLoading,
  } = useContext(techappContext);

  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    getTickets(1);
    getBadgesReq();
    setCurrentPage(1);
  }, []);

  return (
    <>
      {/* loading */}
      {loading && <Loading title={"در حال بارگذاری تیکت ها"} />}
      {/* view list */}
      {!loading &&
        tickets?.length > 0 &&
        tickets.map((ticket, index) => (
          <TicketCard key={index} ticket={ticket} index={index} />
        ))}
      {/* pagination loading */}
      {!loading &&
        tickets?.length > 0 &&
        currentPage < totalPage &&
        paginateLoading && (
          <img
            style={{ width: "40px", margin: "15px 0 10px 0" }}
            src={loadingSvg}
            alt="loading"
          />
        )}
      {/* load more */}
      {!loading &&
        tickets?.length > 0 &&
        currentPage < totalPage &&
        !paginateLoading && (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              cursor: "pointer",
              margin: "15px 0 10px 0",
            }}
            onClick={() => {
              getTickets(currentPage + 1);
              setCurrentPage(currentPage + 1);
            }}
          >
            <span style={{ fontSize: "12px" }}>موارد بیشتر</span>
            <img
              src={loadMoreIcon}
              style={{ width: "16px", marginRight: "5px" }}
              alt="load more"
            />
          </div>
        )}
      {/* empty */}
      {!loading && tickets?.length === 0 && (
        <Empty title={"اعلانی یافت نشد."} />
      )}
    </>
  );
};
export default TicketPage;
